"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IntroPageFUR = void 0;
const react_1 = __importDefault(require("react"));
const react_native_1 = require("react-native");
const atome_1 = require("../../../atome");
const native_base_1 = require("native-base");
const Breakpoints_1 = require("../../../../helper/Breakpoints");
const organisms_1 = require("../../../organisms");
const AbortFUPModal_1 = require("./AbortFUPModal");
function IntroPageFUR(props) {
    const { navigation, setCurrentPage, showFUPRModal, setShowFUPRModal } = props;
    const next = () => {
        let reducerType = {
            type: '[UPDATE]',
            payload: {
                followUpPrescriptionsIndex: 2,
            },
        };
        setCurrentPage(reducerType);
    };
    return (react_1.default.createElement(react_native_1.SafeAreaView, null,
        react_1.default.createElement(native_base_1.ScrollView, { bgColor: "#fff", h: "100%", w: "100%" },
            Breakpoints_1.isDesktop && react_1.default.createElement(organisms_1.UserHeader, { navigation: navigation }),
            react_1.default.createElement(native_base_1.VStack, { space: 5, alignItems: 'center' },
                react_1.default.createElement(native_base_1.Center, { w: "100%", mt: "150" },
                    react_1.default.createElement(atome_1.Icon, { icon: "document-plus", size: 120 })),
                react_1.default.createElement(native_base_1.Center, { w: "100%", mt: "10" },
                    react_1.default.createElement(native_base_1.Text, { fontSize: "2xl", w: "80%", textAlign: "center", color: "#3db384", fontWeight: "bold" }, "In wenigen Schritten zum Folgerezept")),
                react_1.default.createElement(native_base_1.Center, { w: "100%", mt: "5" },
                    react_1.default.createElement(native_base_1.Text, { textAlign: "center", color: "#000", w: "80%" }, "Um ein Folgerezept beantragen zu k\u00F6nnen, braucht Ihr behandelnder Arzt eine R\u00FCckmeldung zum aktuellen Stand der Therapie und Ihrem Gesundheitszustand.")),
                react_1.default.createElement(native_base_1.Center, { w: "100%", mt: "10" },
                    react_1.default.createElement(native_base_1.Button, { w: ['35%', '10%'], alignSelf: 'center', backgroundColor: '#3db384', borderRadius: "3xl", _text: { color: '#fff', fontWeight: 'bold' }, onPress: next }, "Weiter"))),
            react_1.default.createElement(AbortFUPModal_1.AbortFUPModal, { navigation: navigation, setCurrentPage: setCurrentPage, showFUPRModal: showFUPRModal, setShowFUPRModal: setShowFUPRModal }))));
}
exports.IntroPageFUR = IntroPageFUR;
